export enum Empresa {
    SMX = 'SMX',
    LOGZ = 'LOGZ',
    SAFF = 'SAFF'
  }